import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useAppStore } from '@/popup/store/AppStore'
import SomethingWentWrongErrorModal from '@/popup/components/Modal/SomethingWentWrongErrorModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SomethingWentWrongErrorWrapper',
  setup(__props) {

const appStore = useAppStore()

return (_ctx: any,_cache: any) => {
  const _component_ModalTransition = _resolveComponent("ModalTransition")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_ModalTransition, null, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(SomethingWentWrongErrorModal, null, null, 512 /* NEED_PATCH */), [
          [_vShow, _unref(appStore).somethingWentWrongErrors.length > 0]
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})